var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9328 5.02607C13.0738 3.53819 10.9262 3.53819 10.0672 5.02607L3.30234 16.7431C2.44331 18.231 3.5171 20.0909 5.23515 20.0909H18.7649C20.4829 20.0909 21.5567 18.231 20.6977 16.7431L13.9328 5.02607ZM11.0897 13.8744L10.7147 8.41016H12.9647L12.5897 13.8744H11.0897ZM13.2861 16.1244C13.2861 16.8345 12.7105 17.4102 12.0004 17.4102C11.2903 17.4102 10.7147 16.8345 10.7147 16.1244C10.7147 15.4144 11.2903 14.8387 12.0004 14.8387C12.7105 14.8387 13.2861 15.4144 13.2861 16.1244Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f4eb2e5f59c3e5d5fc7c91dbac0fd29d.svg";
export { ForwardRef as ReactComponent };